/// <reference path="./../Container/Container.ts" />
/// <reference path="./../Editor/DSelector.ts" />
namespace HA.Core.HTML {
    import FSApp = HA.Core.Entity.FSApp;
    import DSelector = HA.Core.HTML.Editor.DSelector;

    export class UImg extends Container {

        protected getImg(): Img {
            return this.get("img");
        }

        protected createSelf(): void {
            super.createSelf();
            this.addClass("uimg");
            const fc = this.get("fc");
            const cont = fc ? new FlexContainer() : new CFlexContainer();
            const img = new Img(toMap({
                alt: this.get("ti"),
                h: this.get("h"),
                load : this.get("loading"),
                src: this.getImageSrc(),
                w: this.get("w"),
            }));
            this.addToData("img", img);
            this.appendChild(cont);
            const imgC = new Div({class : "imgc"});
            imgC.appendChild(img);
            cont.appendChild(imgC);
            if (this.has("ti")) {
                const ti = new Div(this.translate(this.get("ti")));
                ti.addClass("ti");
                cont.appendChild(ti);
            }

            const sd = this.get("sd");

            if (sd && sd !== "") {
                const ctac = new Div({classes: ["ctac", "btnShadow"]});
                const cta = new Tag({html: "<i></i>", classes: ["rimg", "fad", "fa-camera"]});
                this.addToData("cta", ctac);
                ctac.appendChild(cta);
                cont.appendChild(ctac);
                this.getCTA().onClick(() => {
                    this.handleClick();
                });
            }
        }

        private getCTA(): Tag {
            return this.get("cta");
        }

        private closeModal(): void {
            getAppService().closeFSApp(this.getAppId());
        }

        private handleClick(): void {
            const app2 = HA.Core.Service.App.createFSApp(this.loadSelector());
            this.setAppId(app2.getId());
            this.showModal(app2);
        }

        private loadSelector(): DSelector | HA.Core.HTML.Editor.MultiMedia {

            if (this.has("selector")) {
                return this.get("selector");
            }

            const sd = this.translateAll(toMap(this.get("sd")));

            if (sd.get("dst") === "url") {
                this.addToData("dst", "url");
                return this.createDSelector(sd);
            }

            this.addToData("dst", "file");
            return this.createMediaSelector(sd);

        }

        private createDSelector(sd: Map<any, any>): DSelector {

            const me = this;
            const selector = new DSelector(toMap({
                pfunc: {
                    itemClick: (d: any) => {
                        me.itemClicked(d);
                    },
                },
                sd,
                waccept: () => {
                    me.closeModal();
                },
                wcancel: () => {
                    me.closeModal();
                },
            }));

            this.addToData("selector", selector);

            return selector;

        }

        private createMediaSelector(sd: Map<any, any>): HA.Core.HTML.Editor.MultiMedia {

            const me = this;
            const selector = new HA.Core.HTML.Editor.MultiMedia(toMap({
                max: 1,
                pfunc: {
                    itemClick: (d: any) => {
                        me.itemClicked(d);
                    },
                },
                sd,
                t: "img",
                tc: 1,
                waccept: () => {
                    me.closeModal();
                },
                wcancel: () => {
                    me.closeModal();
                },
            }));

            this.addToData("selector", selector);
            return selector;

        }

        private itemClicked(data: any): void {
            this.closeModal();

            if (this.get("dst") === "url") {
                this.addToData("mid", data);
                const udata = this.translateAll(this.get("udata"));
                udata.set("mid", data);
                this.getImg().updateSrc(this.getImageSrc());
                getDataRepository().saveData(udata).then((response: Map<any, any>) => {
                    log("enrégistré!");
                });
                return;
            }
            const f: File = data[0].getFile();
            log2(f);
            this.getImg().updateSrc(data[0].getFileData());
            // file
            const form = new FormData();
            form.append("media", f);
            form.append("formId", this.get("formid"));

            getDataRepository().saveForm(form).then((response: Map<any, any>) => {
                getAppService().processAction(response);
            }).catch((reason: any) => {
                log(["eRRRR", reason]);
            });

        }

        private getImageSrc(): string {
            let prefix = this.trans("imb");
            let suffix ="";
            const mid: string = this.translate(this.get("mid"));
            if (!prefix && ((mid && !mid.startsWith("http")) || !mid)) {
                prefix = "/media/img/";
            }
            if (prefix === "-") {
                prefix = "";
            } else {
                suffix = this.get("h") ? "?h=" + this.get("h") + "&w=" + this.get("w") : "";
            }

            return (prefix || "") + mid + suffix;
        }

        private setAppId(id: string) {
            return this.addToData("_appId", id);
        }

        private showModal(app: FSApp) {
            getAppService().showFSApp(app);
        }

        private getAppId(): string {
            return this.get("_appId");
        }
    }
}
